import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const container = css`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const content = css`
  max-width: 720px;
  margin: 30px 30px 100px 30px;
  text-align: center;
`

const imgWrapper = css`
  width: ${rem(280)};
  margin: 0 auto;

  img {
    width: 100%;
  }
`

export const styles = {
  container,
  content,
  imgWrapper,
}
